/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .legal-info-container .title, [_nghost-%COMP%]     .legal-info-container .zone{padding:10px}[_nghost-%COMP%]     .legal-info-container .title{text-transform:uppercase;color:#e8655a;padding-bottom:0}[_nghost-%COMP%]     .legal-info-container .space{margin-top:10px}"];
export { styles as styles };
